module.exports = __webpack_public_path__ + "img/star-of-life.b5628114.svg";